// Password input with the Show / Hide button next to it.
// Used by both FormPasswordInput and FieldControl so they stay in sync.
import React, { useState } from "react";
import { t } from "ttag";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "../../styles/composable/forms.module.scss";

// Readonly<> instead of Immutable<>: a ref has to stay mutable.
type IProps = Readonly<{
    inputProps: Omit<React.ComponentPropsWithRef<"input">, "type">;
}>;

export const PasswordRevealInput = (props: IProps): React.JSX.Element => {
    const [isRevealed, setIsRevealed] = useState(false);

    const onTogglePasswordVisibility = (): void => {
        setIsRevealed((prev) => !prev);
    };

    return (
        /* Literal hooks stay alongside the module classes while legacy
           contextual rules still target them (#34958). */
        <div
            className={concatClassNames([
                styles.formFieldPasswordInputGroup,
                "form__field__password-input-group",
            ])}
        >
            <input
                {...props.inputProps}
                type={isRevealed ? "text" : "password"}
            />
            <button
                type="button"
                className={concatClassNames([
                    styles.formFieldPasswordRevealToggle,
                    "form__field__password-reveal-toggle",
                ])}
                onClick={onTogglePasswordVisibility}
                aria-label={isRevealed ? t`Hide password` : t`Show password`}
            >
                {isRevealed ? t`Hide` : t`Show`}
            </button>
        </div>
    );
};
